import type { ComponentProps } from "react";

import { Badge } from "@/v2-components/ui/badge";
import { BadgeType } from "@/v2-components/global-navigation-bar/_const/navigation-menus";

interface MenuItemBadgeProps {
  badge?: BadgeType;
  className?: string;
  /**
   * 치수는 **`size` 하나로** 정한다. 종전엔 `className = "text-xs"` 기본값이 사실상
   * 크기 노브라, `size` 를 함께 두면 둘이 서로를 덮어(`cn` 은 호출처 우선) 어느 쪽이
   * 걸리는지 호출처에서 안 보였다. 그래서 기본값을 걷고 종전 호출처가 `text-xs` 를
   * 직접 넘긴다.
   *
   * 시안의 GNB 배지는 `sm`(12/16 · 600 · px-6 py-2 · h-20 · r4)이다 —
   * `use-bundle-set-badges.ts` 참고.
   */
  size?: ComponentProps<typeof Badge>["size"];
}

/** Sale/New 배지는 locale 무관 영문 고정 (디자인 컨벤션). t() 미사용. */
export function MenuItemBadge({ badge, className, size }: MenuItemBadgeProps) {
  if (!badge) return null;

  if (badge === "sale") {
    return (
      <Badge variant="sale" size={size} className={className}>
        {"Sale"}
      </Badge>
    );
  }

  if (badge === "new") {
    return (
      <Badge variant="new" size={size} className={className}>
        {"New"}
      </Badge>
    );
  }

  return null;
}
